export const GET_NAV_REQUEST = "GET_NAV_REQUEST";
export const GET_NAV_SUCCESS = "GET_NAV_SUCCESS";
export const GET_NAV_FAILURE = "GET_NAV_FAILURE";

export const GET_ALERTS_REQUEST = "GET_ALERTS_REQUEST";
export const GET_ALERTS_SUCCESS = "GET_ALERTS_SUCCESS";
export const GET_ALERTS_FAILURE = "GET_ALERTS_FAILURE";